import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: 'input[matInput][required], textarea[matInput][required], select[matNativeControl][required], mat-select[required]',
  standalone: false
})
export class MatPlaceholderAsteriskDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}

  ngAfterViewInit(): void {
    const input = this.el.nativeElement;
    const placeholder = input.getAttribute('placeholder');

    if (placeholder && !placeholder.trim().endsWith('*')) {
      input.setAttribute('placeholder', `${placeholder.trim()} *`);
    }
  }
}
